'use client';

import { ProductListsProvider } from '@contexts/ProductListsContext';
import { QueryClientProvider } from '@tanstack/react-query';
import { CartManagementProvider } from '@unity/commerce-core';
import type { PropsWithChildren } from 'react';
import { useMiniCartIslandConfig } from '../useMiniCartIslandConfig';
import { CommerceCartRootProvider } from './CommerceCartRootContext';
import { CommerceCartRootSync } from './CommerceCartRootSync';

const CommerceCartRootInner = ({ children }: PropsWithChildren) => {
  const config = useMiniCartIslandConfig();
  return (
    <CommerceCartRootProvider value={config}>
      <QueryClientProvider client={config.queryClient}>
        <CartManagementProvider
          key={config.providerKey}
          locale={config.locale}
          userId={config.userId}
          organizationId={config.organizationId}
          initialValues={config.initialValues}
        >
          <CommerceCartRootSync
            isHeld={config.hasCartOrganizationChanged}
            isGuest={config.isGuest}
            guestCartId={config.guestCartId}
          />
          {children}
        </CartManagementProvider>
      </QueryClientProvider>
    </CommerceCartRootProvider>
  );
};

/**
 * The one commerce-core provider of a MULTI_CART page (CPS-8537): the header
 * mini-cart and the page share its client, cart and query cache.
 */
export const CommerceCartRoot = ({ children }: PropsWithChildren) => (
  <ProductListsProvider>
    <CommerceCartRootInner>{children}</CommerceCartRootInner>
  </ProductListsProvider>
);
